/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */
export const rem = (px: number): string => `${px / 16}rem`;

export namespace FontSizes {
    export const size8 = rem(8);
    export const size10 = rem(10);
    export const size12 = rem(12);
    export const size14 = rem(14);
    export const size16 = rem(16);
    export const size18 = rem(18);
    export const size20 = rem(20);
    export const size22 = rem(22);
    export const size24 = rem(24);
    export const size28 = rem(28);
    export const size32 = rem(32);
    export const size42 = rem(42);
    export const size68 = rem(68);
}
